// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"e1763bc7","450":"39e98c46"}[chunkId] + ".chunk.css";
};